module.exports = __webpack_public_path__ + "img/avatar01.4a135fd4.jpg";